<template>
  <main class='Program' v-if='kirby.page.template="program"'>


    <section class='main events' v-if='kirby.pages[$route.params.year]'>
      <h6 v-html='kirby.pages[$route.params.year].children.program.strings.maineventstitle' />
      <nav>
        <InOrOutLink :outside='page.strings.toggle == "true"'
                     :href='page.strings.toggle == "true" ? page.strings.link : ("/"+page.uri)'
                     v-show='page.visible'
                     v-for='page in getPagesFromPaths(yaml(kirby.pages[$route.params.year].children.program.strings.main))'
                     :key='page.uid'>
           <h4 class='time'>
             <time>{{formattedDate(page.strings.startdate, 'd.m.')}}</time>
             <span v-if='page.strings.startdate!=page.strings.enddate&&page.strings.startdate&&page.strings.enddate'>-</span>
             <time>{{formattedDate(page.strings.enddate, 'd.m.yy')}}</time>
           </h4>
           <summary>
            <header>
              <h4 class='inline' v-html='page.strings.category' />
              <tags>
                <li v-html='page.strings.location' />
              </tags>
            </header>
            <h1 v-html='page.strings.title' />
            <small v-if='page.strings.englishsummary'>
              <section class='english' v-html='page.strings.englishsummary' />
              <section class='finnish' v-html='page.strings.finnishsummary' />
            </small>
          </summary>
          <figure>
            <srcset v-if='page.files' :file='page.files[yaml(page.strings.cover)]' sizes='15vw' />
          </figure>
        </InOrOutLink>
      </nav>
    </section>

    <section class='all events' v-if='kirby.pages[$route.params.year]'>
      <h6 v-html='kirby.pages[$route.params.year].children.program.strings.alleventstitle' />
      <nav>
        <InOrOutLink :outside='page.strings.toggle == "true"'
                     :href='page.strings.toggle == "true" ? page.strings.link : ("/"+page.uri)'
                     v-show='page.visible'
                     v-for='page in getPagesFromPaths(yaml(kirby.pages[$route.params.year].children.program.strings.all))'
                     :key='page.uid'>
                    <h4 class='time'>
                      <time v-if='page.strings.startdate!==page.strings.enddate'>{{formattedDate(page.strings.startdate, 'd.m.')}}</time>
                      <span v-if='page.strings.startdate!=page.strings.enddate&&page.strings.startdate&&page.strings.enddate'>-</span>
                      <time>{{formattedDate(page.strings.enddate, 'd.m.yy')}}</time>
                    </h4>
                    <summary>
                      <header>
                        <h4 class='inline' v-html='page.strings.category' />
                        <tags>
                          <li v-html='page.strings.location' />
                        </tags>
                      </header>
                      <h1 v-html='page.strings.title' />
                      <small v-if='page.strings.englishsummary'>
                        <section class='english' v-html='page.strings.englishsummary' />
                        <section class='finnish' v-html='page.strings.finnishsummary' />
                      </small>
                    </summary>
                    <figure v-if='page.strings.cover'>
                      <srcset v-if='page.files' :file='page.files[yaml(page.strings.cover)]' sizes='15vw' />
                    </figure>
        </InOrOutLink>
      </nav>
    </section>

    <MainFooter />

  </main>
</template>

<script>
import mixins from '.././mixins.js';
export default {
  mixins: [mixins], //kirby(), urltopath(), etc
}
</script>

<style scoped >
  main > section {
    margin-top: 9rem;
    margin-bottom: 9rem;
  }

  nav {
    margin-top: 1rem;
  }

  header {
    box-sizing: border-box;
    padding: 0;
    margin-bottom: 0.15em;
  }
  h1 {
    display: block;
    box-sizing: border-box;
    line-height: 1em;
    margin: 0;
    padding: 0;
    margin-left: -0.1rem;
  }
  summary {
    flex-grow: 1;
    width: calc(100% - 13.5rem);
  }
  @media screen and (max-width: 700px) {
    summary {
      width: calc(100%);
    }
  }
  h4.inline {
    margin: 0;
    display: inline-block;
    width: auto;
    text-transform: uppercase;
    margin-right: 1rem;
    margin-bottom: 0.75rem;
  }
  small {
    margin-top: 2em;
    box-sizing: border-box;
    max-width: 50em;
    font-size: var(--small);
    display: flex;
    gap: 2em;
  }
  small > section {
    width: 50%;
  }
  figure {
    max-width: 12rem;
    display: block;
  }

  h6 {
    margin-bottom: 3rem;
  }
</style>

<style>

  main.Program > section > nav header ul {
    display: inline-block;
    vertical-align: top;
  }

  main.Program > section > nav a {
    width: var(--oversize);
    border-top: var(--thinline);
    padding-top: 1.5rem;
    display: flex;
    gap: 2rem;
    align-items: stretch;
    flex-direction: var(--columndirection);
    padding-bottom: 6rem;
    width: 100%;
    height: 100%;
    justify-content: space-between;
  }

  main.Program > section > nav a > h4.time {
    display: block;
    vertical-align: top;
    width: 13.5rem;
    box-sizing: border-box;
    flex-grow: 1;
  }

  main.Program > section > nav a * {
    color: var(--gray);
    will-change: color;
    transition: color 0.3s ease-in-out;
  }
  main.Program > nav a:hover * {
    color: var(--darkgray);
  }
</style>
